import { Theme } from "@radix-ui/themes";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { queryClient } from "@/lib/query-client";
import { routeTree } from "./routeTree.gen";
import { useAuthStore } from "@/stores/auth.store";

// Créer le router avec le contexte auth
const router = createRouter({
  routeTree,
  basepath: "/",
  context: {
    auth: undefined!, // sera injecté via AuthProvider
  },
});

// Type-safety du router
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  const auth = useAuthStore();

  return (
    <QueryClientProvider client={queryClient}>
      <Theme
        appearance="light"
        accentColor="indigo"
        grayColor="slate"
        radius="medium"
        scaling="100%"
        hasBackground
      >
        <RouterProvider router={router} context={{ auth }} />
        <Toaster position="top-right" richColors />
      </Theme>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
